import { create } from 'zustand'
import type { PaletteCategoryId } from './paletteViews'

interface CommandPaletteState {
	isOpen: boolean
	setOpen: (isOpen: boolean) => void
	/** Project creation lives in the switcher rather than on a page, so the palette hosts its dialog. */
	isCreateProjectOpen: boolean
	openCreateProject: () => void
	setCreateProjectOpen: (isOpen: boolean) => void
	/** Read once by the dialog on mount (e.g. from the `C` shortcut), then cleared. */
	pendingView: PaletteCategoryId | null
	openWithView: (categoryId: PaletteCategoryId) => void
}

export const useCommandPaletteStore = create<CommandPaletteState>()(set => ({
	isOpen: false,
	setOpen: isOpen => set({ isOpen }),
	isCreateProjectOpen: false,
	openCreateProject: () => set({ isCreateProjectOpen: true }),
	setCreateProjectOpen: isCreateProjectOpen => set({ isCreateProjectOpen }),
	pendingView: null,
	openWithView: categoryId => set({ isOpen: true, pendingView: categoryId }),
}))
